<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-sm my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Машин нэмэх</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Нэр</label>
                      <input
                        v-model.trim="lesson.name"
                        type="text"
                        class="form-control"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="Нэр"
                      />
                    </div>
                    <div class="form-group">
                      <label>Тайлбар мэдээлэл</label>
                      <textarea
                        v-model.trim="lesson.description"
                        type="text"
                        class="form-control"
                        id="exampleInputPassword"
                        placeholder="Дэлгэрэнгүй"
                        rows="10"
                      />
                    </div>
                    <div class="form-group">
                      <label>Үнэ</label>
                      <input
                        v-model.trim="lesson.price"
                        type="number"
                        class="form-control"
                        placeholder="Үнэ"
                      />
                    </div>
                    <div class="form-group">
                      <label>Үлдэгдэл</label>
                      <input
                        v-model.trim="lesson.quantity"
                        type="number"
                        class="form-control"
                        placeholder="Үлдэгдэл"
                      />
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Төрөл:</label>
                        <select class="form-control" v-model="carstate">
                          <option
                            v-for="cstate in carstates"
                            v-bind:key="cstate.id"
                            v-bind:value="cstate"
                          >{{cstate.data().name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Үйлдвэрлэгч:</label>
                          <select class="form-control" v-model="cartype" @change="schoolChanged">
                            <option
                              v-for="(ct, index) in cartypes"
                              v-bind:key="ct.id"
                              v-bind:value="ct"
                            >{{index+1}}. {{ct.data().name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="cartype!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Марк:</label>
                          <select class="form-control" v-model="carmark">
                            <option
                              v-for="(carmark, index) in cartype.carmarks"
                              v-bind:key="carmark.id"
                              v-bind:value="carmark"
                            >{{index+1}}. {{carmark.data().name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col" v-if="carmark!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Үйлдвэрлэсэн он:</label>
                          <select class="form-control" v-model="caryear">
                            <option
                              v-for="(pro, index) in carmark.years"
                              v-bind:key="pro.id"
                              v-bind:value="pro"
                            >{{index+1}}. {{pro.data().name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="caryear!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Модел:</label>
                          <select class="form-control" v-model="carmodel">
                            <option
                              v-for="(modl, index) in caryear.models"
                              v-bind:key="modl.id"
                              v-bind:value="modl"
                            >{{index+1}}. {{modl.data().name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!--                   
                    <div class="form-group">
                       <label>Зорилго</label>
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="result" type="text" class="form-control" placeholder="Зорилго"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addResult" class="btn btn-success btn-block">
                            нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.results!=null && lesson.results.length>0">
                        <li  v-for="(include,index) in lesson.results" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.results)"></i>
                        </li>
                      </ul>
                    </div>-->
                    <hr />
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">Хадгалах</div>
                      </div>
                    </div>
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
export default {
  name: "CarAdd",
  data() {
    return {
      lesson: {
        name: "",
        description: "",
        prices: [],
        adding: [],
        quantity: null,
        price: null
      },
      performingRequest: false,
      result: "",
      cartypes: [],
      carstate:null,
      cartype: null,
      carmark: null,
      caryear: null,
      carmodel: null,

      carstates: [],
      semester: null,
      lessonTypes: [
        "Ерөнхий эрдэм",
        "Мэргэжлийн",
        "Мэргэжлийн суурь",
        "Сонгох",
        "Магистр",
        "Доктор"
      ]
    };
  },
  methods: {
    save() {
      this.performingRequest = true;
      if (this.lesson != null && this.lesson.name != "") {
        this.lesson.name = this.capitalizeFirstLetter(this.lesson.name);
        this.lesson.userId = this.$store.getters.currentUser.uid;
        this.lesson.user = fb.usersCollection.doc(
          this.$store.getters.currentUser.uid
        );

        if (
          this.$store.getters.userProfile != null &&
          this.$store.getters.userProfile.owner != null
        )
          this.lesson.owner = this.$store.getters.userProfile.owner;

        this.lesson.createdAt = new Date();

        if (this.cartype != null) {
          this.lesson.cartype = this.cartype.ref;
          //   this.school.ref.update({
          //     'numberOfLessons': fb.firestore.FieldValue.increment(1)
          //   });
        }
        if (this.carmark != null) {
          this.lesson.carmark = this.carmark.ref;
        }
        if (this.caryear != null) {
          this.lesson.caryear = this.caryear.ref;
        }
        if (this.carmodel != null) {
          this.lesson.carmodel = this.carmodel.ref;
        }

        if (this.carstate != null) {
          this.lesson.carstate = this.carstate.ref;
        }
        fb.db
          .collection("cars")
          .doc()
          .set(this.lesson);

        // if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
        //   this.lesson.teacher=this.$store.getters.userProfile.customer;
        //   this.lesson.teacher.update({'numberOfLessons':fb.firestore.FieldValue.increment(1)});
        // }

        this.$router.back();
      } else {
        alert("Нэр оруулж xадгална уу");
      }
    },
    setLesson() {
      this.lesson = {
        name: "",
        description: "",
        included: [],
        lectureCode: "",
        profession: "",
        requirements: [],
        results: [],
        whatlearned: [],
        skills: [],
        handlaga: [],
        semester: null,
        quantity: null,
        price: null,
        types: []
      };
    },
    addResult() {
      if (this.result != null && this.result != "") {
        if (this.lesson == null || this.lesson == undefined) this.setLesson();
        this.lesson.results.push(this.result);
        this.result = "";
      }
    },
    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },

    _getSchools() {
      fb.db
        .collection("cartypes")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(cartype => {
            this._getMark(cartype.id, cartype);
            this.cartypes.push(cartype);

            // fb.db.collection("lessons").where("school", "==", schoolData.ref).get().then(values=>{
            //   schoolData.ref.update({"numberOfLessons": values.size});
            // });

            // fb.db.collection("lessons").where("school", "==", schoolData.ref).where("published","==", true).get().then(values=>{
            //   schoolData.ref.update({"publishedLesson": values.size});
            // });
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });

      fb.db
        .collection("carstates")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(data => {
            this.carstates.push(data);
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getMark(schoolId, cartype) {
      cartype.ref
        .collection("marks")
        .get()
        .then(querySnapshot => {
          let carmarks = [];
          querySnapshot.forEach(mark => {
            this._getYear(mark);
            carmarks.push(mark);

            // fb.db.collection("lessons").where("department", "==", depdata.ref).get().then(values=>{
            //   depdata.ref.update({"numberOfLessons": values.size});
            // });

            // fb.db.collection("lessons").where("department", "==", depdata.ref).where("published","==", true).get().then(values=>{
            //   depdata.ref.update({"publishedLesson": values.size});
            // });
          });
          cartype.carmarks = carmarks;
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getYear(mark) {
      mark.ref
        .collection("years")
        .get()
        .then(querySnapshot => {
          let years = [];
          querySnapshot.forEach(caryear => {
            this._getModel(caryear);
            years.push(caryear);
            // fb.db.collection("lessons").where("program", "==", prodata.ref).get().then(values=>{
            //   prodata.ref.update({"numberOfLessons": values.size});
            // });

            // fb.db.collection("lessons").where("program", "==", depdata.ref).where("published","==", true).get().then(values=>{
            //   prodata.ref.update({"publishedLesson": values.size});
            // });
          });
          mark.years = years;
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getModel(caryear) {
      caryear.ref
        .collection("models")
        .get()
        .then(querySnapshot => {
          let models = [];
          querySnapshot.forEach(caryear => {
            this._getModel(caryear);
            models.push(caryear);
            // fb.db.collection("lessons").where("program", "==", prodata.ref).get().then(values=>{
            //   prodata.ref.update({"numberOfLessons": values.size});
            // });

            // fb.db.collection("lessons").where("program", "==", depdata.ref).where("published","==", true).get().then(values=>{
            //   prodata.ref.update({"publishedLesson": values.size});
            // });
          });
          caryear.models = models;
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    schoolChanged() {
      this.department = null;
      this.program = null;
    },
    // depChanged(){
    //   console.log(this.department)
    //   this.programs=[]
    //   if(this.department!=null && this.department.id!=null)
    //     this._getPros("schools/"+this.school.id+"/departments/"+this.department.id+"/programs");
    // }
    addType(type) {
      if (this.lesson.types == null || this.lesson.types == undefined)
        this.lesson.types = [];
      if (!this.lesson.types.includes(type)) this.lesson.types.push(type);
      else this.lesson.types.splice(this.lesson.types.indexOf(type), 1);
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },

  created() {
    var _this = this;
    this.semester = this.semesterId;
    this._getSchools();
  },
  props: {
    semesterId: {
      required: false
    }
  }
};
</script>

